<template>
  <el-main class="page-content-margin-unset">
    <div class="dk-li">
      <h3
        style="display:inline-block">项目信息</h3>
    </div>
    <el-table
      border
      :data="body">
      <el-table-column
        prop="order_info.order_id"
        label="订单号"/>
      <el-table-column
        prop="order_info.create_time"
        label="创建时间"/>
      <el-table-column
        prop="order_info.nickname"
        label="用户昵称"/>
      <el-table-column
        prop="order_info.mobile"
        label="手机号"/>
      <el-table-column
        prop="order_info.money"
        label="订单金额"/>
      <el-table-column
        prop="order_info.point"
        label="积分抵扣"/>
      <el-table-column
        prop="order_info.paid_money"
        label="实际支付金额"/>
      <el-table-column
        prop="order_info.pay_type"
        label="支付方式">
      </el-table-column>
      <el-table-column
        prop="order_info.create_time"
        label="提交时间"/>
      <el-table-column
        prop="order_info.status"
        label="订单状态"/>
      <el-table-column
        prop="order_info.invite_code"
        label="推荐人ID"/>
    </el-table>
    <h3>收货地址</h3>
    <el-table
      border
      :data="order_address">
      <el-table-column
        prop="name"
        label="收货人"/>
      <el-table-column
        prop="mobile"
        label="联系电话"/>
      <el-table-column
        label="收货地址">
        <template slot-scope="scope">
          <span>
            {{ scope.row.province }}
            {{ scope.row.city }}
            {{ scope.row.county }}
            {{ scope.row.detail_address }}
          </span>
        </template>
      </el-table-column>
    </el-table>
    <h3>商品信息</h3>
    <el-table
      border
      :data="order_detail">
      <el-table-column
        label="商品图片">
        <template slot-scope="scope">
          <img
            width="148px"
            :src="imgDomain + scope.row.img_src"
            alt="">
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        prop="product_name"
        label="商品标题"/>
      <el-table-column
        prop="standard_name"
        label="商品规格"/>
      <el-table-column
        prop="quantity"
        label="数量"/>
      <el-table-column
        prop="paid_money"
        label="商品价格"/>
    </el-table>
    <h3>售后信息</h3>
    <div class="detail" v-if="body[0]">
      <el-form
        :inline="false"
        status-icon
        label-position="left"
        label-width="80px"
        class="demo-ruleForm">
        <el-form-item
          v-if="body[0].status !== '问题关闭'"
          class="dk-input"
          label="提交时间:">
          <span>{{body[0].create_time}}</span>
        </el-form-item>
        <el-form-item
          class="dk-input"
          label="问题描述:">
          <span>{{body[0].describe}}</span>
        </el-form-item>
        <el-form-item
          class="dk-input"
          label="问题描述:" >
          <div style="display: flex;width: 700px;flex-wrap:wrap">
            <img
              width="150px"
              height="150px"
              style="margin: 0 10px 10px 0;"
              v-for="(item, i) in body[0].img_list"
              :src="imgDomain + '/' + item.key"
              @click="imgPre(imgDomain + '/' + item.key)"/>
          </div>
        </el-form-item>
        <el-form-item
          v-if="body[0].status === '问题关闭'"
          class="dk-input"
          label="处理说明:">
          <span>{{body[0].content}}</span>
        </el-form-item>
        <el-form-item
          v-if="body[0].status === '问题关闭'"
          class="dk-input"
          label="处理时间:">
          <span>{{body[0].handle_time}}</span>
        </el-form-item>
        <el-button
          type="primary"
          @click="event().toBrackClick()">返 回</el-button>
        <el-button
          v-if="body[0].status !== '问题关闭'"
          type="primary"
          @click="event().toSetComplete()">完成关闭</el-button>
      </el-form>
    </div>

    <!-- 完成关闭 -->
    <el-dialog
      width="340px"
      title="提示，请输入关闭理由？"
      :visible.sync="setCompleteDialog">
      <el-form
        :model="setCompleteBody"
        ref="ruleForm3"
        class="demo-ruleForm">
        <el-input
          type="textarea"
          class="dk-input"
          v-model="setCompleteBody.content"/>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer">
        <el-button @click="setCompleteDialog = false">取 消</el-button>
        <el-button
          type="primary"
          @click="event().onSureSetCompleteClick('ruleForm3')">确 定</el-button>
      </div>
    </el-dialog>
    <modal :url='imgPreUrl' :modal='modal' style="width:100%" @chose='chose'></modal>
  </el-main>
</template>

<script>
  import {getAfterSaleDetail, setComplete} from '../../api/after-sale'
  import { imgDomain } from '../../configs/env'
  import modal from '../../components/modal'

export default {
  data() {
    // eslint-disable-next-line
    const checkMoney = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('支付金额不能为空'));
      }
      if (!Number.isInteger(value)) {
        callback(new Error('请输入数字值'));
      } else {
        callback();
      }
    };
    return {
      imgDomain,
      conditionTitle: false,
      conditionDialog: true,
      status: '',
      body: [],
      order_detail: [
      ],
      order_address: [],
      setCompleteDialog: false,
      setCompleteBody: {},
      imgPreUrl:'',
      modal:false,
    };
  },
  created() {
    this.network().getAfterSaleDetail()
  },
  methods: {
    imgPre(url){
      this.modal=true
      this.imgPreUrl=url
    },
    chose(e){
      this.modal=e
    },
    event() {
      return {
        toBrackClick: () => {
          this.$router.go(-1)
        },
        onSureSetCompleteClick: () => {
          this.network().setComplete()
        },
        toSetComplete: () => {
          this.setCompleteBody.uuid = this.$route.query.uuid
          this.setCompleteDialog = true
        },
      }
    },
    network() {
      return {
        getAfterSaleDetail: async () => {
          const { status, data } = await getAfterSaleDetail({'uuid': this.$route.query.uuid})
          if (status !== 200) return
          this.body = [data]
          this.order_detail = data.order_detail
          this.order_address = [data.order_address]
        },
        setComplete: async () => {
          const { status } = await setComplete(this.setCompleteBody)
          if (status !== 200) return
          this.network().getAfterSaleDetail()
          this.setCompleteDialog = false
          this.$notify({
            title: '关闭成功',
            message: '关闭成功',
            type: 'success',
          });
        },
      }
    },
    handler() {
      return {
      }
    },
  },
  components: {
    modal,
  },
};
</script>

<style scoped lang="scss">
@import '../../assets/styles/mixins.scss';
.page-content-margin-unset{
  .dk-from{
    display: flex;
  }
  .detail{
    display: flex;
  }
  .table-top{
    @include dk-table-top;
  }
  .img{
    min-width: 148px;
    height: 148px;
    border-radius: 6px;
    border: 1px solid #c0ccda;
    margin: 0 20px 20px 0;
  }
}
</style>



// WEBPACK FOOTER //
// src/vuepage/after-sale/detail.vue